var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"msg"},[_c('h1',[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" "+_vm._s(_vm.msg)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }